// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"adf7f8cd","198":"7627bb53","404":"9f38c68e","473":"533d1ba5","498":"d001a82d","544":"38052aa6","764":"5aa92a3c","849":"77dd354a"}[chunkId] + ".chunk.js";
};